export default __webpack_public_path__ + "static/media/gallery_12.85833d93.jpg";